import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Loading from "../../../components/Loading";
import * as Http from "../../../http";
import * as Business from "../../../utils/business";

export default class IrrbbReportChild extends Component {
  state = {
    isShow: false,
    loading: false,
    items: [],
  };

  show = () => {
    this.setState({ isShow: true, loading: true });
    Http.getIrrbbOutputs(this.props.report.file_name).then((data) => {
      const items =
        data && data.Success && data.Data
          ? data.Data.map((o) => ({
              output_type: o.output_type,
              created: Business.convertToFullDate(o.created_time),
            }))
          : [{ output_type: "IRRBB_REPORT", created: "" }];
      this.setState({ items, loading: false });
    }).catch(() => {
      this.setState({
        items: [{ output_type: "IRRBB_REPORT", created: "" }],
        loading: false,
      });
    });
  };

  close = () => {
    this.setState({ isShow: false });
  };

  render() {
    const { report } = this.props;
    const shortName = String(report.file_name).substring("IRRBB_".length);

    return (
      <div>
        <a
          href="#url"
          style={{ color: "blue" }}
          onClick={(e) => {
            e.preventDefault();
            this.show();
          }}
        >
          {shortName}
        </a>
        <Modal show={this.state.isShow} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>
              {report.report_date
                ? Business.convertToDate(report.report_date) + " # " + shortName
                : shortName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.loading ? (
              <div style={{ height: 80 }}>
                <Loading size="small" />
              </div>
            ) : (
              <div>
                <table className="table table-hover table-striped">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Output</th>
                      <th>Created Time</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.items.map((item, idx) => (
                      <tr key={item.output_type}>
                        <td>{idx + 1}</td>
                        <td>{item.output_type}</td>
                        <td>{item.created}</td>
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            style={{
                              backgroundColor: "#FFE600",
                              borderColor: "#7F7E82",
                              color: "#000",
                              fontWeight: 600,
                              borderRadius: 20,
                              fontSize: 12,
                              padding: "4px 14px",
                            }}
                            onClick={() =>
                              Http.downloadIrrbbReport(report.file_name)
                            }
                          >
                            <i className="pe-7s-download" /> Download
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div style={{ textAlign: "right", marginTop: 8 }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{
                      backgroundColor: "#FFE600",
                      borderColor: "#7F7E82",
                      borderRadius: 20,
                      fontWeight: 600,
                      fontSize: 12,
                      padding: "6px 20px",
                      color: "#1a1a3e",
                    }}
                    onClick={() => Http.downloadIrrbbReport(report.file_name)}
                  >
                    <i className="pe-7s-download" /> SAVE ALL FILES
                  </button>
                </div>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/IRRBB/Reports/IrrbbReportChild.js